import { render, staticRenderFns } from "./limitsReserch3.vue?vue&type=template&id=89fd87d8&"
import script from "./limitsReserch3.vue?vue&type=script&lang=js&"
export * from "./limitsReserch3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports